import { Generator, ModelID, SearchParams } from '@/types';

export type Filter = 'all' | 'active' | 'inactive';
export type Sort = 'created_at' | 'updated_at' | 'generator_id';
export interface GeneratorSearchParams extends SearchParams<Filter, Sort>, Partial<Generator> {
  with_status?: boolean;
}

export const featurePath = '/v4/equipment/generator';

export const featureKeys = {
  all: [{ scope: 'generator' }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: GeneratorSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
